// extracted by mini-css-extract-plugin
export default {"header":"GraficaCuestionario_header__k9pwZ"};